/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-06",
    versionChannel: "nightly",
    buildDate: "2025-05-06T00:06:54.609Z",
    commitHash: "9111b84f785fc160e78ec272175c1cf879c6a8e6",
};
